module.exports = __webpack_public_path__ + "static/media/sopt6kz.ab0534b7.pdf";